import { render, staticRenderFns } from "./PortfolioPageItem.vue?vue&type=template&id=e3e48444&scoped=true"
import script from "./PortfolioPageItem.vue?vue&type=script&lang=js"
export * from "./PortfolioPageItem.vue?vue&type=script&lang=js"
import style0 from "./PortfolioPageItem.vue?vue&type=style&index=0&id=e3e48444&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3e48444",
  null
  
)

export default component.exports